var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useSheetRowActions, useSheetRowsById, useSheetRowsByParentId } from '../../data/sheetRow/sheetRowHooks';
export function useLockRows() {
    var _this = this;
    var sheetRowsById = useSheetRowsById();
    var sheetRowsByParentId = useSheetRowsByParentId();
    var batchUpdate = useSheetRowActions().batchUpdate;
    var lockRows = function (sheetRowIds, newValue) { return __awaiter(_this, void 0, void 0, function () {
        var updates, i, cId, sheetRow;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updates = [];
                    for (i = 0; i < sheetRowIds.length; i++) {
                        cId = sheetRowIds[i];
                        sheetRow = sheetRowsById[cId];
                        if (sheetRow && sheetRow.readonly !== newValue) {
                            updates.push(__assign(__assign({}, sheetRow), { readonly: newValue }));
                        }
                    }
                    return [4 /*yield*/, batchUpdate(updates)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var lockRowsAndSubRows = function (sheetRowIds, newValue) { return __awaiter(_this, void 0, void 0, function () {
        var updates, addIds, i, clusterId, sheetRow;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updates = [];
                    addIds = function (sheetRow) {
                        var e_1, _a;
                        if (sheetRow.readonly !== newValue) {
                            updates.push(__assign(__assign({}, sheetRow), { readonly: newValue }));
                        }
                        var children = sheetRowsByParentId[sheetRow.id] || [];
                        try {
                            for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                                var child = children_1_1.value;
                                addIds(child);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    };
                    for (i = 0; i < sheetRowIds.length; i++) {
                        clusterId = sheetRowIds[i];
                        sheetRow = sheetRowsById[clusterId];
                        if (sheetRow) {
                            addIds(sheetRow);
                        }
                    }
                    return [4 /*yield*/, batchUpdate(updates)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        lockRows: lockRows,
        lockRowsAndSubRows: lockRowsAndSubRows,
    };
}
